<app-spinner [active]="loading"></app-spinner>
<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-6.jpg)' }"
  class="content-header"
>
  <span class="header-title">Jumpers</span>
</div>
<div class="form">
  <div class="section-container">
    <div class="title">
      <span>Jumpers - Edit Last Day off</span>
    </div>
    <p class="active-jumper-warning">
      This jumper list shows only active jumpers. If a jumper does not appear in
      the list, visit 'Jumpers' to change the status of a jumper to active.
    </p>
  </div>
  <div class="section-container split">
    <div class="left-section">
      <div class="datum">
        <span class="number one">1</span>
        <app-dropdown
          [choice]="selectedBase"
          label="Base"
          [options]="bases"
          key="displayValue"
          (selectedDropdownItem)="selectBase($event)"
        ></app-dropdown>
      </div>
      <div class="datum">
        <span class="number two">2</span>
        <input
          aria-label="Choose Date"
          type="date"
          [(ngModel)]="selectedDate"
          placeholder="Choose Date"
        />
        <span class="required-asterisk">*</span>
      </div>
    </div>
    <div class="jumper-box-title-container">
      <span class="number three">3</span>
      <span class="jumper-box-title">Jumpers</span>
    </div>
    <div class="right-section">
      <div class="jumper datum" *ngFor="let jumper of jumpers; index as i">
        <div class="checkbox-container">
          <input
            aria-label="Select Jumper"
            type="checkbox"
            [(ngModel)]="jumper.checked"
            [name]="jumper.name"
          />
          <span class="ldo-jumper-name"
            >{{ jumper.lastName }}, {{ jumper.firstName }}</span
          >
        </div>
        <span class="ldo-date">{{ jumper.ldo }}</span>
      </div>
    </div>
  </div>
  <div class="section-container submit-button-container">
    <app-button
      [disabled]="isDisabled()"
      [text]="buttonText"
      (clicked)="updateJumperLDO($event)"
    ></app-button>
  </div>
</div>
